import "./header.css";
import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";

const Header = ({ title = false, text1 = "", text2 = "" }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showcaseOpen, setShowcaseOpen] = useState(false);
  const [scorecardOpen, setScorecardOpen] = useState(false);
  const location = useLocation();
  const menuRefs = useRef({});
  const [menuDropdownOpenId, setMenuDropdownOpenId] = useState(null);

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen((open) => !open);
  };

  useEffect(() => {
    function handleClick(e) {
      if (!menuDropdownOpenId) return;

      const activeDropdown = menuRefs.current[menuDropdownOpenId];
      console.log("active dropdown", activeDropdown, e.target);

      if (activeDropdown && activeDropdown.contains(e.target)) {
        return;
      }

      setMenuDropdownOpenId(null);
    }

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [menuDropdownOpenId]);

  return (
    <header>
      <div className="header-wrapper large-screen-limit">
        <div className="header-nav">
          <div className="image-column">
            <div
              className="hamburger"
              onClick={handleMobileMenuToggle}
              aria-expanded={mobileMenuOpen}
              title="main menu"
            >
              <i className="fa-solid fa-bars" aria-hidden="true"></i>
            </div>
            <a href="/">
              <img src="/images/header-footer/newlogo3.svg" alt="arise" />
            </a>
          </div>

          <nav
            className={
              mobileMenuOpen ? "global-navbar mobile-open" : "global-navbar"
            }
          >
            {mobileMenuOpen && (
              <div
                className="close-global-menu"
                onClick={handleMobileMenuToggle}
              >
                <i class="fa-solid fa-xmark"></i>
              </div>
            )}
            <ul>
              <li>
                <a
                  href="/"
                  id="home"
                  className={location.pathname === "/" ? "active" : ""}
                >
                  Home
                </a>
              </li>

              <li
                className={
                  location.pathname.includes("/showcase")
                    ? "dropdown active"
                    : "dropdown"
                }
              >
                <span
                  id="showcase-nav"
                  onClick={() => setMenuDropdownOpenId(1)}
                >
                  Showcase{" "}
                  <i
                    className={`fa-solid ${
                      showcaseOpen ? "fa-angle-up" : "fa-angle-down"
                    }`}
                    aria-hidden="true"
                  ></i>
                </span>

                {menuDropdownOpenId === 1 && (
                  <div
                    className="nav-dropdown-menu"
                    ref={(el) => (menuRefs.current[1] = el)}
                  >
                    <a
                      href="/showcase/innovations"
                      className="nav-dropdown-item"
                      onClick={() => setMenuDropdownOpenId(null)}
                    >
                      <i className="fa-solid fa-angle-right"></i> Showcase
                      Innovations
                    </a>
                    <a
                      href="/showcase/presentations"
                      className="nav-dropdown-item"
                      onClick={() => setShowcaseOpen(false)}
                    >
                      <i className="fa-solid fa-angle-right"></i> Showcase
                      Presentations
                    </a>
                  </div>
                )}
              </li>

              <li
                className={
                  location.pathname.includes("/scorecard")
                    ? "dropdown active"
                    : "dropdown"
                }
              >
                <span id="scorecard" onClick={() => setMenuDropdownOpenId(2)}>
                  Scorecard{" "}
                  <i
                    className={`fa-solid ${
                      scorecardOpen ? "fa-angle-up" : "fa-angle-down"
                    }`}
                    aria-hidden="true"
                  ></i>
                </span>

                {menuDropdownOpenId === 2 && (
                  <div
                    className="nav-dropdown-menu"
                    ref={(el) => (menuRefs.current[2] = el)}
                  >
                    <a
                      href="/scorecard"
                      className="nav-dropdown-item"
                      onClick={() => setMenuDropdownOpenId(null)}
                    >
                      <i className="fa-solid fa-angle-right"></i> Scorecard Home
                    </a>
                    <a
                      href="/scorecard/instructions"
                      className="nav-dropdown-item"
                      onClick={() => setScorecardOpen(false)}
                    >
                      <i className="fa-solid fa-angle-right"></i> Scorecard
                      Instructions
                    </a>
                    <a
                      href="/scorecard/news"
                      className="nav-dropdown-item"
                      onClick={() => setScorecardOpen(false)}
                    >
                      <i className="fa-solid fa-angle-right"></i> Scorecard News
                    </a>
                    <a
                      href="/scorecard/participation"
                      className="nav-dropdown-item"
                      onClick={() => setScorecardOpen(false)}
                    >
                      <i className="fa-solid fa-angle-right"></i> Scorecard
                      Participation
                    </a>
                    <a
                      href="/scorecard/faq"
                      className="nav-dropdown-item"
                      onClick={() => setScorecardOpen(false)}
                    >
                      <i className="fa-solid fa-angle-right"></i> Scorecard FAQs
                    </a>
                    <a
                      href="/scorecard/about"
                      className="nav-dropdown-item"
                      onClick={() => setScorecardOpen(false)}
                    >
                      <i className="fa-solid fa-angle-right"></i> Scorecard
                      About
                    </a>
                    <a
                      href="/scorecard/subscribe"
                      className="nav-dropdown-item"
                      onClick={() => setScorecardOpen(false)}
                    >
                      <i className="fa-solid fa-angle-right"></i> Scorecard
                      Subscribe
                    </a>
                    <a
                      href="/scorecard/contact"
                      className="nav-dropdown-item"
                      onClick={() => setScorecardOpen(false)}
                    >
                      <i className="fa-solid fa-angle-right"></i> Scorecard
                      Contact
                    </a>
                  </div>
                )}
              </li>

              <li>
                <a
                  href="/sponsors"
                  className={location.pathname === "/sponsors" ? "active" : ""}
                >
                  Sponsor
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className={location.pathname === "/about" ? "active" : ""}
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="/contact-us"
                  className={
                    location.pathname === "/contact-us" ? "active" : ""
                  }
                >
                  Contact
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
